import { ChangeEvent, useMemo, useState } from 'react';

import { useEventUsersQuery } from '../../../event/hooks/useEventUsersQuery';

export const useEventUsersDrawer = (
  eventId: string,
  hasPaid?: boolean,
  excludeUserIds?: string[],
) => {
  const [search, setSearch] = useState<string>('');

  const { data: eventUsersData } = useEventUsersQuery(eventId, hasPaid);

  const eventUsers = useMemo(
    () =>
      (eventUsersData?.eventUsers ?? []).filter((eventUser) => {
        if (excludeUserIds?.includes(eventUser.id)) {
          return false;
        }

        return `${eventUser.firstname} ${eventUser.lastname}. ${eventUser.nickname} ${eventUser.studyTown} ${eventUser.studies} ${eventUser.email}`
          .toLowerCase()
          .includes(search.toLowerCase());
      }),
    [eventUsersData?.eventUsers, excludeUserIds, search],
  );

  const clearSearch = () => {
    setSearch('');
  };

  const onSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  return { eventUsers, clearSearch, onSearchChange, search };
};
